import { render, staticRenderFns } from "./BannerTypeModalForm.vue?vue&type=template&id=19ecc38d"
import script from "./BannerTypeModalForm.vue?vue&type=script&lang=js"
export * from "./BannerTypeModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports